import {
  DataTableColumnColorProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { RefParamRepository } from '../../../../store/ref-param-state/ref-param-state.repository';
import { RefParams } from '@/types';

interface getRefParamsDataTableStructureProps {
  store: RefParamRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getRefParamsDataTableStructure = ({
  store,
  createAction,
  rowActions,
  serverQuery,
}: getRefParamsDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.refParams.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const codeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.refParams.table.code',
    accessorKey: 'code',
    variant: DataTableColumnVariant.TEXT,
  };
  const descriptionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.refParams.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };
  const typeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.refParams.table.refType',
    accessorKey: 'refType.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const codeColorColumn: DynamicDataTableColumn<DataTableColumnColorProps> = {
    label: 'settings.refParams.table.codeColor',
    accessorKey: 'codeColor',
    variant: DataTableColumnVariant.COLOR,
    renderAs: (value: any) => {
      return value ? { value, class: `bg-[${value}] border` } : { value: 'common.values.no_value', class: '' };
    },
  };

  return {
    singular: 'settings.refParams.table.singular',
    plural: 'settings.refParams.table.plural',
    columns: [idColumn, codeColumn, descriptionColumn, typeColumn, codeColorColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: RefParams) => {
      store.set('dto', {
        code: row.code,
        description: row.description,
        refTypeId: row.refType?.id,
        codeColor: row.codeColor || '#ffffff',
      });
      store.set('response', row);
      store.set('refTypeIdSelected', { name: row.refType?.description, code: row.refType?.id });
      store.set('codeColorColorSelected', { originalEvent: { isTrusted: false }, value: row.codeColor || '#ffffff' });
    },
    createAction,
    rowActions,
    enableServerActions: true,
    serverQuery,
    searchableFields: ['id', 'code', 'description', 'refType.description', 'codeColor'],
  };
};
